import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainSearch, Glitch_SearchRequest } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, ComplainSearch_GroupBy, AuthActionCodes, GlitchSearch_GroupBy, GlitchStatuses } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, ListResponse } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import * as moment from 'moment';
const momentDuration = require("moment-duration-format");
import { ComplainService } from '../../Services/ComplainService';
import { GenericMaster, GenericMaster_String, LocationLookup, CallDescriptionLookup, CallCategoryLookup, VIP } from '../../Models/GlobalEntities';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { GlitchService } from '../../Services/GlitchService';

@Component({
    selector: 'GlitchSearchResult',
    templateUrl: './GlitchSearchResult.html'
})

export class GlitchSearchResult extends BaseComponent implements OnInit, OnDestroy {
    _RequestModel: Glitch_SearchRequest;
    Model: ListResponse;
    DateFormat: string;
    Timer: any;
    cDate: Date = new Date();
    SortParams: Array<GenericMaster_String> = [];
    SortByText: string = "";

    _GlitchSearch_GroupBy = GlitchSearch_GroupBy;
    _Statuses = GlitchStatuses;
    @Input() HideTotalPages: boolean = false;
    @Input() Compact_Mode: boolean = false;
    @Output() onResultRefresh: EventEmitter<number> = new EventEmitter<number>();

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, public complainService: ComplainService, public glitchService: GlitchService) {
        super(translate, toastr, route, router, masterService);
        this.CreateSortParams();
    }

    CreateSortParams(): void {
        this.SortParams = [
            { Id: "LogTime desc", Name: "BTN.BTN_DATE_ADDED" }
            , { Id: "GlitchIncedentDt desc", Name: "BTN.BTN_INCIDENTDATE_DESC" }
            , { Id: "IncidentLocationId desc", Name: "BTN.BTN_LOCATION_DESC" }
            , { Id: "LastUpdate desc", Name: "BTN.BTN_UPDATED_DATE_TIME" }
        ]
    }

    ngOnDestroy(): void {
        window.clearInterval(this.Timer);
        //this.complainService.JobConsoleRefreshEvent.;
    }


    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
        // this.RequestModel.Properties.push(this.masterService.LoggedInUserData.PropertyId);

        let m: any;
        m = momentDuration;
        m(moment);

        this.Timer = setInterval(() => this.onTimeLeftTimer(), 1000);
    }

    @Input("RequestModel") set RequestModel(Model: Glitch_SearchRequest) {
        //console.info(Model);
        this._RequestModel = Model;
    }

    get RequestModel(): Glitch_SearchRequest {
        return this._RequestModel;
    }

    @Input() Show(): void {
        if (this.RequestModel != null) {
            let defSort = this.SortParams.find(a => a.Id == this.RequestModel.OrderBy);
            if (defSort != null)
                this.SortByText = defSort.Name;
        }
        this.SetData();
    }

    onTimeLeftTimer(): void {
        this.cDate = new Date();

        if (this.Model == null)
            return;

        if (this.Model.Result == null)
            return;

        for (let i = 0; i < this.Model.Result.length; i++) {
            let row = this.Model.Result[i];

            row.ElaspedTimeText = "";

            if (row.IsOpen == true) {
                let dtEnd = moment();
                let dtNow = moment(row.LogTime);
                let dura = moment.duration(dtEnd.diff(dtNow));
                //console.info(row.JobEndTime);

                row.ElaspedTimeText = dura.format('dd:hh:mm:ss', { trim: 'all' });
            }
        }
    }

    SetData(): void {
        if (this.RequestModel == null)
            return;

        this.complainService.SelectedJob = null;

        this.IsSubmitting = true;

        //console.info(this.RequestModel);

        this.glitchService.Glitch_Search(this.RequestModel).then(data => {
            this.Model = data;
            this.RequestModel.PageNumber = data.CurrentPage;
            this.onTimeLeftTimer();
            this.IsSubmitting = false;

            //this.onResultRefresh.emit(1);

        }).catch(reason => {
            console.info(reason);
            this.IsSubmitting = false;
        })
    }

    onRowSelected(row: any): void {
        if (row == null) {
            this.glitchService.SelectedGlitch = null;
            this.complainService.increasePopupOpacity = false;
            return;
        }

        if (this.glitchService.SelectedGlitch != null && this.glitchService.SelectedGlitch.GlitchId == row.GlitchId){
            this.complainService.increasePopupOpacity = false;
            this.glitchService.SelectedGlitch = null;
        }else {
            this.complainService.increasePopupOpacity = true;
            this.glitchService.SelectedGlitch = row;
        }
    }

    onPageChange(): void {
        this.SetData();
    }

    onFilter(row: GenericMaster_String): void {
        this.RequestModel.OrderBy = row.Id;
        this.SortByText = row.Name;
        this.SetData();
    }

    onJobConsoleToUpdate(ComplainId: number): void {
        //this.SetData();
    }

    isFilterMatch(data: any): boolean {
        let m = true;

        if (data.DeptId == null) {
            return false;
        }

        if (this.RequestModel.Properties != null && this.RequestModel.Properties.length > 0) {
            if (this.RequestModel.Properties.findIndex(a => a == data.PropertyId) < 0)
                return false;
        }

        if (this.CheckAuth_Dept_Action(data.PropertyId, data.DeptId, AuthActionCodes.GlitchView) == false)
            return false;

        if (this.RequestModel.Departments != null && this.RequestModel.Departments.length > 0) {
            if (this.RequestModel.Departments.findIndex(a => a == data.DeptId) < 0)
                return false;
        }

        if (this.RequestModel.GlitchCategories != null && this.RequestModel.GlitchCategories.length > 0) {
            if (this.RequestModel.GlitchCategories.findIndex(a => a == data.CategoryId) < 0)
                return false;
        }

        if (this.RequestModel.GlitchDescriptions != null && this.RequestModel.GlitchDescriptions.length > 0) {
            if (this.RequestModel.GlitchDescriptions.findIndex(a => a == data.DescriptionId) < 0)
                return false;
        }

        

        if (this.RequestModel.Locations != null && this.RequestModel.Locations.length > 0) {
            if (this.RequestModel.Locations.findIndex(a => a == data.LocationId) < 0)
                return false;
        }

        return m;
    }
}
